import {Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {CrudService} from "../index";
import {Country} from "../../dto/country";
import {DataListModel} from "../../models/data-list-model";

@Injectable()
export class CountryService implements CrudService<Country> {
  constructor(
    private http: HttpClient,
  ) {
  }

  readonly apiPath = "countries/";

  delete(id: any): Observable<Object> {
    throw new Error("Method not implemented.");
  }

  restore(id: any): Observable<Object> {
    throw new Error("Method not implemented.");
  }

  deleteMany(list: any[]): Observable<Object> {
    throw new Error("Method not implemented.");
  }

  restoreMany(list: any[]): Observable<Object> {
    throw new Error("Method not implemented.");
  }

  getMany(): Observable<DataListModel<Country>> {
    return this.http.get(this.apiPath) as Observable<DataListModel<Country>>;
  }

  getManyEuFirst(): Observable<DataListModel<Country>> {
    let httpParams = new HttpParams();
    httpParams = httpParams.set('sort', 'eu-first');

    return this.http.get(this.apiPath, {params: httpParams}) as Observable<DataListModel<Country>>;
  }

  get(id: number): Observable<Country> {
    return this.http.get(this.apiPath + id) as Observable<Country>;
  }

  add(country: Country): Observable<Object> {
    return this.http.post(this.apiPath, country);
  }

  update(id: number, country: Country): Observable<Object> {
    return this.http.put(this.apiPath + id, country);
  }
}
